import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { DelinquencyRestrictionDialogComponent } from './delinquency-restriction-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        RouterModule
    ],
    exports: [DelinquencyRestrictionDialogComponent],
    declarations: [DelinquencyRestrictionDialogComponent]
})
export class DelinquencyRestrictionDialogModule {}
